
import { get } from '../../share/find'

/**
 * row
 * user
 * group
 * base
 */

type Commands = 'null' | 'equal' | 'not-equal' | 'concat' | 'index'
class Internal {
  commands: [Commands, any[]]
  constructor(commands: [Commands, any[]]) {
    this.commands = commands
  }

  callbacks(name: string, params: any) {
    switch (name) {
      case 'null':
        return (values: any) => {
          const target = get(params[1].replace('$', ''), values[params[0].replace('$', '')])

          return target === '-'
        }
      case 'not-null':
        return (values: any) => {
          const target = get(params[1].replace('$', ''), values[params[0].replace('$', '')])

          return target !== '' && target !== '-'
        }
      case 'equal':
        return (values: any) => {
          const [hashKey, needle] = params

          const source = typeof hashKey === 'object' ? values[hashKey[0]][hashKey[1]] : hashKey
          const target = typeof needle === 'object' ? values[needle[0]][needle[1]] : needle

          return source === target && source !== '-' && target !== '-'
        }
      case 'not-equal':
        return (values: any) => {
          const [hashKey, needle] = params

          const source = typeof hashKey === 'object' ? values[hashKey[0]][hashKey[1]] : hashKey
          const target = typeof needle === 'object' ? values[needle[0]][needle[1]] : needle

          return source !== target
        }

      default: {
        return () => void 0
      }
    }
  }

  run(values: any) {
    const defaultValues = {
      group: {},
      user: {},
      row: {},
      ...values,
    }

    return this.callbacks(this.commands[0], this.commands[1])(defaultValues)
  }
}

class External extends Internal {
  constructor(params: any) {
    super(params)
  }
}

export const Operator = {
  internal: Internal,
  external: External,
}

export const runOperator = (field: any, values: any) => {
  let disabled: any = field.disabled
  let hidden: any = field.hidden

  if (field.disabled !== undefined && field.disabled.type == 'operator') {
    const operator = new Operator.external(field.disabled.commands)

    disabled = operator.run(values)
  }

  if (field.hidden !== undefined && field.hidden.type == 'operator') {
    const operator = new Operator.external(field.hidden.commands)

    hidden = operator.run(values)
  }

  return {
    disabled,
    hidden,
  }
}
